const getObeStatusBullet = {
  New: 'yellow',
  Active: 'green',
  Awaiting: 'grey',
  Inactive: 'grey',
  Shipped: 'yellow',
  Frozen: 'grey',
  Lost: 'red',
  Terminated: 'red',
  Rejected: 'red',
  Cancelled: 'red',
  ApprovedAwaitingShipping: 'yellow',
  AwaitingApproval: 'grey',
  AwaitngDeactivation: 'red',
  AwaitingDeactivation: 'red',
  BeingReplaced: 'red'
};
export default getObeStatusBullet;